import { graphql, useStaticQuery } from 'gatsby';

const usePlaybookChapters = () => {
  const { contentfulWebsitePage } = useStaticQuery(graphql`
    query {
      contentfulWebsitePage(contentful_id: { eq: "1GwsdVOznKAOaXdM5irQHi" }) {
        components {
          ... on ContentfulWebsiteContentBlock {
            title: heading
            sections: collection {
              ... on ContentfulRichText {
                slug: anchorId
                title: sectionTitle
              }
            }
            title: heading
            description: subhead {
              subhead
            }
          }
        }
      }
    }
  `);
  return contentfulWebsitePage?.components;
};

export default usePlaybookChapters;
